import React from 'react'
import { COPYRIGHT_NAME,COPYRIGHT_URL } from 'configs/AppConfig';

export default function Footer() {
	return (
		<footer className="footer">
			<span>Copyright  &copy;  {`${new Date().getFullYear()}`} <span className="font-weight-semibold"><a href={`${COPYRIGHT_URL}`} target='_blank'>{`${COPYRIGHT_NAME}`}</a></span>. All rights reserved.</span>
		</footer>
	)
}

